<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div class="list-box" style="flex: 1; overflow: hidden">
      <ul class="list-search">
        <el-space wrap style="flex: 1">
          <el-input
            v-model="state.params.keywords"
            style="width: 200px"
            placeholder="姓名、手机号、证件号"
            clearable
            @clear="
              delete state.params.keywords;
              onLoad();
            "
            @paste.enter="$onKeywordsPaste($event, state.params)"
          ></el-input>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
        <el-button
          type="primary"
          :icon="Upload"
          link
          @click="onExport"
          size="large"
          >导出
        </el-button>
      </ul>
      <div
        class="table-container"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <table
          cellpadding="20"
          cellspacing="0"
          v-if="Array.isArray(state.tableData)"
        >
          <thead>
            <tr>
              <th style="white-space: nowrap">
                <div style="width: 40px; white-space: nowrap; text-align: left">
                  序号
                </div>
              </th>
              <th style="white-space: nowrap">姓名</th>
              <th style="white-space: nowrap; text-align: center">算税状态</th>
              <th style="white-space: nowrap">发放状态</th>
              <th style="white-space: nowrap">报送状态</th>
              <th style="white-space: nowrap">扣缴义务人</th>
              <th
                style="white-space: nowrap"
                v-for="item in state.templateSortFields.filter(
                  (w) => w.name != '姓名'
                )"
                :key="item"
              >
                <div
                  style="resize: horizontal; overflow-x: auto; min-width: 100px"
                >
                  {{ item.name }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in state.tableData" :key="row">
              <td style="white-space: nowrap">
                <div style="width: 40px; white-space: nowrap; text-align: left">
                  {{
                    (state.params.page - 1) * state.params.limit + rowIndex + 1
                  }}
                </div>
              </td>
              <td style="white-space: nowrap">
                {{ row.name }}
              </td>
              <td style="white-space: nowrap">
                <el-tooltip
                  effect="dark"
                  :content="row.tax_failure_msg"
                  v-if="row.tax_failure_msg"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="payrollemployee_tax_status"
                      :value="row.tax_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="payrollemployee_tax_status"
                  :value="row.tax_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </td>
              <td style="white-space: nowrap">
                <el-tooltip
                  effect="dark"
                  :content="row.pay_failure_msg"
                  v-if="row.pay_failure_msg"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="payrollemployee_pay_status"
                      :value="row.pay_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="payrollemployee_pay_status"
                  :value="row.pay_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </td>
              <td style="white-space: nowrap">
                <el-tooltip
                  effect="dark"
                  :content="row.declare_failure_msg"
                  v-if="row.declare_failure_msg"
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      cursor: pointer;
                    "
                  >
                    <c_status
                      arrName="employeedeclare_declare_status"
                      :value="row.declare_status"
                    />
                    <el-icon><QuestionFilled /></el-icon>
                  </div>
                </el-tooltip>
                <c_status
                  arrName="employeedeclare_declare_status"
                  :value="row.declare_status"
                  style="margin: 0 auto"
                  v-else
                ></c_status>
              </td>
              <td style="white-space: nowrap">
                <div
                  v-if="row.withholding_agent_name"
                  :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                  :style="{
                    '--dynamic-color':
                      row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                  }"
                  class="withholding-badge"
                >
                  {{ row.withholding_agent_name }}
                </div>
                <text v-else>-</text>
              </td>
              <td
                style="white-space: nowrap; text-align: center"
                v-for="item in state.templateSortFields.filter(
                  (w) => w.name != '姓名'
                )"
                :key="item"
              >
                {{ row[item.field] || "-" }}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: left">合计</td>
              <td v-for="item in state.statistics" :key="item">
                {{ item }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新专项附加扣除"
        @close="state.showAgent = false"
      >
        <c_Agent
          :skssq="state.params.skssq"
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_EssentialLog></c_EssentialLog>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive, ref, h, watch } from "vue";
import { calctax_records, calctax_records_export } from "@/http/calctax";
import { priceFormat } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 100,
    page: 1,
  };
}
export default {
  props: {
    id: Number,
    keywords: String,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      statistics: [],
      templateSortFields: [],
    });
    onMounted(() => {
      state.params.id = props.id;
      onLoad();
    });

    watch(
      () => props.keywords,
      (value) => {
        if (value) state.params.keywords = value;
      }
    );

    const onLoad = () => {
      delete state.tableData;

      calctax_records(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list, statistics, templateSortFields } = res.data.data;
          state.tableData = list;
          state.templateSortFields = templateSortFields;
          state.totalCount = count;

          let tjArr = [];
          const keys = Object.keys(statistics);
          keys.forEach((key) => {
            const index = state.templateSortFields.findIndex(
              (w) => w.field == key
            );
            if (index > -1) tjArr[index + 3] = priceFormat(statistics[key]);
          });
          tjArr.length = tjArr.length + 6;
          state.statistics = tjArr;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    const getSummaries = () => {
      let res = [];
      res[0] = h("div", { style: { whiteSpace: "nowrap" } }, ["合计"]);
      const keys = Object.keys(state.statistics);
      keys.forEach((key) => {
        const index = state.templateSortFields.findIndex((w) => w.field == key);
        if (index > -1) res[index + 5] = priceFormat(state.statistics[key]);
      });

      return res;
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      calctax_records_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      getSummaries,
      onExport,
    };
  },
};
</script>
<style lang="less" scoped>
.table-container::-webkit-scrollbar {
  width: 15px;
  height: 15px;
}

.table-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #61b0f5;
}

.table-container::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: transparent;
}

.table-container {
  min-height: 100px;
  overflow-y: auto; /* 垂直滚动条 */
  display: block; /* 或者使用 overflow: scroll; */
  border: 1px solid #ebeef5;
  font-size: 14px;
  color: #606266;

  table {
    width: 100%; /* 或者具体的宽度 */
    border-collapse: separate; /* 合并边框 */
  }

  thead th {
    position: sticky; /* 使表头固定 */
    top: 0; /* 固定在顶部 */
    z-index: 1; /* 确保表头在其他内容之上 */
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
    color: #909399;
  }

  th,
  td {
    position: -webkit-sticky; /* Safari */
    position: sticky;
  }

  /* 固定第一列 */
  thead th:first-child {
    top: 0;
    left: 0;
    z-index: 10; /* 确保在最上层 */
    background-color: #fff;
  }

  /* 固定第一列 */
  thead th:nth-child(2) {
    top: 0;
    left: 80px;
    z-index: 10; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody td:first-child {
    left: 0;
    z-index: 2; /* 确保在最上层 */
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
  }

  /* 固定第一列 */
  tbody td:nth-child(2) {
    top: 0;
    left: 80px;
    z-index: 10; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody td {
    border-bottom: 1px solid #ebeef5;
  }

  /* 固定第一列 */
  thead th:last-child {
    top: 0;
    right: 0;
    z-index: 10; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody td:last-child {
    right: 0;
    z-index: 2; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody tr:last-child {
    position: sticky; /* 使表头固定 */
    background-color: #fff;
    bottom: 0;
    z-index: 30; /* 确保在最上层 */
    background-color: #fff;

    & > td {
      padding-top: 10px;
      padding-bottom: 10px;
      background-color: rgb(246, 246, 246);
      text-align: center;
    }
  }
}
</style>
